exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".travels-container{padding:60px 0}@media screen and (max-width:1240px){.travels-container{padding:40px 20px}}.box-destinies-container{display:flex}@media screen and (max-width:500px){.box-destinies-container{display:grid;grid-template-columns:1fr 1fr}}", ""]);

// exports
